export const COLORS = {
  bg: "#F6F1EB",
  bgSoft: "#FBF7F2",
  surface: "#FFFDFC",
  surface2: "#F3ECE4",
  surface3: "#EAE0D6",
  border: "#D8C7B8",
  borderSoft: "#E8DDD2",
  text: "#201A17",
  textSoft: "#6F6258",
  textMuted: "#9A8D82",
  primary: "#B85C38",
  primaryHover: "#A24E2E",
  primarySoft: "#EBC8B6",
  accent: "#7A8E76",
  accentSoft: "#DCE6D8",
  gold: "#B9925A",
  danger: "#D97C6C",
  dangerSoft: "#F6DFDA",
  success: "#6F9D7A",
  successSoft: "#DDEBDD",
  shadow: "0 10px 30px rgba(32, 26, 23, 0.08)",
  shadowHover: "0 18px 44px rgba(32, 26, 23, 0.12)",
  cardGlow: "0 1px 0 rgba(255,255,255,0.7) inset",
};

export const baseTransition = "all 180ms ease";

export const radius = {
  sm: 12,
  md: 18,
  lg: 24,
  xl: 32,
  pill: 999,
};
